export default {
  'invitation.language': '语言',
  'invitation.templateName': '模版名称',
  'invitation.operator': '操作人',
  'invitation.operationTime': '操作时间',
  'invitation.operation': '操作',
  'invitation.edit': '编辑',
  'invitation.invitee': '受邀人',
  'invitation.join': '参加',
  'invitation.jinbiaos': '锦标赛',
  'invitation.Reward': '奖励',
  'invitation.peopleInviterGetsReward1': '邀请人获得奖励',
  'invitation.modify': '修改',
  'invitation.tickets': '张门票',
  'invitation.invitationRewardMode': '邀请奖励模式',
  'invitation.ladderMode': '阶梯模式',
  'invitation.ladderConfig': '阶梯配置',
  'invitation.addLadder': '添加阶梯',
  'invitation.ladder': '阶梯',
  'invitation.totalInvitations': '总邀请数达到',
  'invitation.mustBeGreaterThanLadder': '必须大于阶梯 {index} 的人数 ({prevValue})',
  'invitation.peopleInviterGets': '人，邀请人获得',
  'invitation.ticketsReward': '张门票',
  'invitation.afterCompletingAllLadders': '当完成以上所有阶梯后，每',
  'invitation.peopleInviterGetsReward': '人，邀请人获得',
  'invitation.ticketsRewardFinal': '张门票',
  'invitation.label.ticket': '门票数量',
  'invitation.label.bonus': '奖金',
  'invitation.validator.twoElectOne': '门票和奖金必须填写其中一项',
  'invitation.inviteeKycRequired': '受邀人完成KYC，邀请人获得奖励',
};
